module.exports = __webpack_public_path__ + "img/Angeschlagener_Raum_Halber_Raum.dad8f1f3.svg";